$(document).on("turbolinks:load", function () {
  // *** ルールフォーム要素チェック ***

  const rule_play_type_radios = $('input[name="rule[play_type]"]');
  let play_type = $('input[name="rule[play_type]"]:checked').val();

  const js_uma_four = $(".js-uma_four");
  const templateButtons = $('.rule-form__template-tag');
  const templateHintDisabled = $('.js-template-hint-disabled');
  if (!js_uma_four.length) return;

  const mochi = $("#rule_mochi");
  const kaeshi = $("#rule_kaeshi");
  const uma_one = $("#rule_uma_one");
  const uma_two = $("#rule_uma_two");
  const uma_three = $("#rule_uma_three");
  const uma_four = $("#rule_uma_four");
  const rule_tie_option_radios = $('input[name="rule[tie_option]"]');
  const scoring_mode_radios = $('input[name="rule[scoring_mode]"]');
  if (
    !rule_play_type_radios.length ||
    !uma_one.length ||
    !uma_two.length ||
    !uma_three.length ||
    !uma_four.length
  )
    return;

  // *** ensureHiddenField / removeHiddenField ヘルパー ***
  function ensureHiddenField(id, name, value) {
    const form = $('.rule-form').closest('form');
    if (!form.length) return;
    const existing = form.find('#' + id);
    if (existing.length) {
      existing.val(value);
      return;
    }
    $('<input>').attr({ type: 'hidden', id: id, name: name, value: value }).appendTo(form);
  }

  function removeHiddenField(id) {
    $('#' + id).remove();
  }

  // *** scoring_mode切替時のUI制御 ***
  // resetValues: true = モード切替時（値をリセット）、false = 初期ロード時（既存値を保持）
  function updateScoringModeUI(resetValues) {
    const mode = $('input[name="rule[scoring_mode]"]:checked').val();
    if (mode === 'float_based') {
      $('.js-uma-section').hide();
      $('.js-float-based-table').show();
      // 同点時の順位: 「同順位で順位点を分配する」に固定表示
      $('#rule_tie_option_2').prop('checked', true);
      rule_tie_option_radios.prop('disabled', true);
      $('.js-tie-option-hidden').prop('disabled', false);
      if (resetValues) {
        uma_one.val(0);
        uma_two.val(0);
        uma_three.val(0);
        uma_four.val(0);
      }
      $('#rule_score_decimal_point_calc').val('1').prop('disabled', true);
      ensureHiddenField('rule_score_decimal_point_calc_hidden', 'rule[score_decimal_point_calc]', '1');
    } else {
      $('.js-uma-section').show();
      $('.js-float-based-table').hide();
      // 同点時の順位: 選択可能に戻す
      rule_tie_option_radios.prop('disabled', false);
      $('.js-tie-option-hidden').prop('disabled', true);
      $('#rule_score_decimal_point_calc').prop('disabled', false);
      removeHiddenField('rule_score_decimal_point_calc_hidden');
      if (resetValues) {
        uma_one.val('');
        uma_two.val('');
        uma_three.val('');
        uma_four.val('');
      }
    }
    checkRuleFormCompletion();
  }

  // *** 三人麻雀制約 ***
  function updateScoringModeAvailability() {
    const play_type = $('input[name="rule[play_type]"]:checked').val();
    if (play_type === '3') {
      $('#rule_scoring_mode_float_based').prop('disabled', true);
      if ($('#rule_scoring_mode_float_based').prop('checked')) {
        $('#rule_scoring_mode_standard').prop('checked', true);
        updateScoringModeUI(true);
      }
    } else {
      $('#rule_scoring_mode_float_based').prop('disabled', false);
    }
  }

  function updateTemplateAvailability() {
    const currentPlayType = $('input[name="rule[play_type]"]:checked').val();
    if (currentPlayType === '4') {
      templateButtons.prop('disabled', false);
      templateHintDisabled.addClass('d-none');
    } else {
      templateButtons.prop('disabled', true);
      templateHintDisabled.removeClass('d-none');
    }
  }

  function updateUmaFourVisibility(currentPlayType) {
    if (currentPlayType === "3") {
      js_uma_four.removeClass("d-block");
      js_uma_four.addClass("d-none");
    } else if (currentPlayType === "4") {
      js_uma_four.removeClass("d-none");
      js_uma_four.addClass("d-block");
    }
  }

  // *** play_type固定処理 ***
  // rules/newのときのみ実行
  if (window.location.pathname.includes("rules/new")) {
    const fixed_play_type = gon.fixed_play_type;

    if (fixed_play_type) {
      // disabled のラジオは送信されないため、hidden で値を必ず送る
      function ensureFixedPlayTypeHiddenField(value) {
        const form = rule_play_type_radios.first().closest("form");
        if (!form.length) return;

        const hiddenId = "fixed_rule_play_type";
        const existing = form.find("#" + hiddenId);
        if (existing.length) {
          existing.val(value);
          return;
        }

        $("<input>")
          .attr({
            type: "hidden",
            id: hiddenId,
            name: "rule[play_type]",
            value: value,
          })
          .appendTo(form);
      }

      // 該当するラジオボタンを選択状態にする
      $('input[name="rule[play_type]"][value="' + fixed_play_type + '"]').prop("checked", true);
      // 変更不可にする
      rule_play_type_radios.prop("disabled", true);
      rule_play_type_radios.attr("tabindex", "-1");
      rule_play_type_radios.addClass("bg-disabled");
      ensureFixedPlayTypeHiddenField(fixed_play_type);
    }
  }

  // 初期ロード時に現在選択されているplay_typeで4位欄の表示/非表示を反映する
  play_type = $('input[name="rule[play_type]"]:checked').val();
  updateUmaFourVisibility(play_type);

  // *** placeholder・持ち点、返し点の初期値変更処理 ***
  // rules/newのときのみ実行
  if (window.location.pathname.includes("rules/new")) {
    if (play_type === "3") {
      mochi.attr("placeholder", "35");
      kaeshi.attr("placeholder", "40");

      mochi.val(35);
      kaeshi.val(40);

      // 三人麻雀の場合は順位点4位を非表示にし、値0とする
      updateUmaFourVisibility(play_type);
      uma_one.attr("placeholder", "20");
      uma_two.attr("placeholder", "0");
      uma_three.attr("placeholder", "-20");
      uma_four.val(0);
    } else if (play_type === "4") {
      mochi.attr("placeholder", "25");
      kaeshi.attr("placeholder", "30");

      mochi.val(25);
      kaeshi.val(30);

      updateUmaFourVisibility(play_type);
      uma_one.attr("placeholder", "20");
      uma_two.attr("placeholder", "10");
      uma_three.attr("placeholder", "-10");
      uma_four.attr("placeholder", "-20");
    }
  }

  // play_type変更があったら
  $('input[name="rule[play_type]"]').change(function () {
    updateScoringModeAvailability();
    updateTemplateAvailability();
    const play_type = $('input[name="rule[play_type]"]:checked').val();
    if (play_type === "3") {
      mochi.attr("placeholder", "35");
      kaeshi.attr("placeholder", "40");

      mochi.val(35);
      kaeshi.val(40);

      // 三人麻雀の場合は順位点4位を非表示にし、値0とする
      updateUmaFourVisibility(play_type);
      uma_one.attr("placeholder", "20");
      uma_two.attr("placeholder", "0");
      uma_three.attr("placeholder", "-20");
      uma_four.val(0);
    } else if (play_type === "4") {
      mochi.attr("placeholder", "25");
      kaeshi.attr("placeholder", "30");

      mochi.val(25);
      kaeshi.val(30);

      uma_four.val("");
      updateUmaFourVisibility(play_type);
      uma_one.attr("placeholder", "20");
      uma_two.attr("placeholder", "10");
      uma_three.attr("placeholder", "-10");
      uma_four.attr("placeholder", "-20");
    }
  });

  // *** チップpt入力フィールドの制御 ***
  const rule_chip_rate = $("#rule_chip_rate");
  const rule_is_chip_radios = $('input[name="rule[is_chip]"]');

  // チップ有無に応じてチップpt入力を有効/無効化する関数
  const chipRateSection = $(".rule-form__chip-rate-section");

  function updateChipRateField() {
    const is_chip = $('input[name="rule[is_chip]"]:checked').val();
    if (is_chip === "true") {
      // チップあり：入力可能にする
      rule_chip_rate.prop("disabled", false);
      rule_chip_rate.removeClass("bg-disabled");
      rule_chip_rate.addClass("bg-white");
      chipRateSection.removeClass("is-disabled");
    } else {
      // チップなし：入力不可にし、値をクリア
      rule_chip_rate.prop("disabled", true);
      rule_chip_rate.removeClass("bg-white");
      rule_chip_rate.addClass("bg-disabled");
      rule_chip_rate.val("");
      chipRateSection.addClass("is-disabled");
    }
  }

  // 初期ロード時にチップpt入力フィールドの状態を設定
  updateChipRateField();

  // チップ有無が変更されたときにチップpt入力フィールドの状態を更新
  rule_is_chip_radios.on("change", updateChipRateField);

  // *** 登録・変更ボタンアクティブ制御処理 ***
  // 必須項目がすべて埋まるとアクティブになる

  const rule_name = $("#rule_name");
  const rule_mochi = $("#rule_mochi");
  const rule_kaeshi = $("#rule_kaeshi");
  const rule_uma_one = $("#rule_uma_one");
  const rule_uma_two = $("#rule_uma_two");
  const rule_uma_three = $("#rule_uma_three");
  const rule_uma_four = $("#rule_uma_four");
  const rule_score_decimal_point_calc = $("#rule_score_decimal_point_calc");

  // ● 送信ボタン上の入力警告を表示・削除する（文言は shared/form/_warning の data 属性から読む）
  function toggleRuleWarning(key, isShown, level) {
    window.Janreco.toggleFormWarning("#rule_form_warning", key, isShown, level);
  }

  // ● 持ち点が返し点を超えているか（両方入力済みのときだけ判定）
  function isMochiOverKaeshi() {
    const mochi = rule_mochi.val().trim();
    const kaeshi = rule_kaeshi.val().trim();
    if (mochi === "" || kaeshi === "") return false;
    return Number(mochi) > Number(kaeshi);
  }

  // ● 順位点の合計が0でないか（standard かつ4つとも入力済みのときだけ判定。三麻は4位が0固定）
  function isUmaSumNotZero(mode) {
    if (mode === "float_based") return false;
    const umaValues = [rule_uma_one, rule_uma_two, rule_uma_three, rule_uma_four].map(function ($uma) {
      return $uma.val().trim();
    });
    if (umaValues.some(function (v) { return v === ""; })) return false;
    const sum = umaValues.reduce(function (acc, v) { return acc + Number(v); }, 0);
    return Math.abs(sum) > 1e-9;
  }

  function checkRuleFormCompletion() {
    // 成績紐づき時は name と description のみ編集可能なので、常にボタン有効
    if (typeof gon !== 'undefined' && gon.has_matches) {
      // 得点・順位点は変更できないため警告を出さない
      toggleRuleWarning("mochi-over-kaeshi", false);
      toggleRuleWarning("uma-sum-not-zero", false);
      const rule_name_filled = rule_name.val().trim().length > 0;
      if (rule_name_filled) {
        $('#rule_create_btn').prop('disabled', false).removeClass('inactive');
      } else {
        $('#rule_create_btn').prop('disabled', true).addClass('inactive');
      }
      return;
    }

    const mode = $('input[name="rule[scoring_mode]"]:checked').val();
    // 毎回最新の値をチェック
    const rule_name_required = rule_name.val().trim().length > 0;
    const rule_mochi_required = rule_mochi.val().trim().length > 0;
    const rule_kaeshi_required = rule_kaeshi.val().trim().length > 0;

    let uma_required;
    if (mode === 'float_based') {
      uma_required = true;
    } else {
      uma_required = rule_uma_one.val().trim().length > 0 &&
                     rule_uma_two.val().trim().length > 0 &&
                     rule_uma_three.val().trim().length > 0 &&
                     rule_uma_four.val().trim().length > 0;
    }

    const rule_score_decimal_point_calc_required =
      rule_score_decimal_point_calc.val().trim().length > 0;
    // ラジオボタンは選択されていれば必須条件を満たす
    const rule_tie_option_required = mode === 'float_based' ||
      $('input[name="rule[tie_option]"]:checked').length > 0;
    const rule_is_chip_required = $('input[name="rule[is_chip]"]:checked').length > 0;

    // チップ有の場合のみチップpt入力フィールドが必須
    const is_chip = $('input[name="rule[is_chip]"]:checked').val();
    let rule_chip_rate_required;
    if (is_chip === "true") {
      // チップあり：チップptの入力が必須
      rule_chip_rate_required = rule_chip_rate.val().trim().length > 0;
    } else {
      // チップなし：チップptは不要なので常にtrue
      rule_chip_rate_required = true;
    }

    const mochiOverKaeshi = isMochiOverKaeshi();

    if (
      rule_name_required &&
      rule_mochi_required &&
      rule_kaeshi_required &&
      uma_required &&
      rule_score_decimal_point_calc_required &&
      rule_tie_option_required &&
      rule_is_chip_required &&
      rule_chip_rate_required &&
      !mochiOverKaeshi
    ) {
      $("#rule_create_btn").prop("disabled", false).removeClass("inactive");
    } else {
      $("#rule_create_btn").prop("disabled", true).addClass("inactive");
    }

    // 持ち点 > 返し点は保存できない（モデルでも検証）ため、ボタンを止めて警告する
    toggleRuleWarning("mochi-over-kaeshi", mochiOverKaeshi, "error");
    // 順位点の合計が0でないルールも保存はできるため、警告だけ出す
    toggleRuleWarning("uma-sum-not-zero", isUmaSumNotZero(mode), "caution");
  }

  // *** プリセット自動入力 ***
  const presets = {
    'm-league-rule-btn': { mochi: 25, kaeshi: 30, uma: [30, 10, -10, -30], decimal: '1', tie: '2', chip: false },
    'saikouisen-rule-btn': { mochi: 30, kaeshi: 30, uma: [30, 10, -10, -30], decimal: '1', tie: '2', chip: false },
    'kyoukai-rule-btn': { mochi: 25, kaeshi: 30, uma: [30, 10, -10, -30], decimal: '1', tie: '2', chip: false },
    'wrc-rule-btn': { mochi: 30, kaeshi: 30, uma: [15, 5, -5, -15], decimal: '1', tie: '2', chip: false },
  };

  function applyPreset(preset, name) {
    // play_typeが固定されている場合（disabled）は無理に変更しない
    if (!rule_play_type_radios.prop('disabled')) {
      $('input[name="rule[play_type]"][value="4"]').prop('checked', true).trigger('change');
    }

    // play_typeが4でない場合は四人麻雀プリセットとして入力できないため処理を中断
    const current_play_type = $('input[name="rule[play_type]"]:checked').val();
    if (current_play_type !== '4') return;

    // scoring_modeをstandardに切替
    $('#rule_scoring_mode_standard').prop('checked', true);
    updateScoringModeUI(true);

    $('#rule_name').val(name).trigger('input');

    mochi.val(preset.mochi).trigger('input');
    kaeshi.val(preset.kaeshi).trigger('input');

    uma_one.val(preset.uma[0]).trigger('input');
    uma_two.val(preset.uma[1]).trigger('input');
    uma_three.val(preset.uma[2]).trigger('input');
    uma_four.val(preset.uma[3]).trigger('input');

    $('#rule_score_decimal_point_calc').val(preset.decimal).trigger('change');

    const chipId = preset.chip ? '#rule_is_chip_true' : '#rule_is_chip_false';
    $(chipId).prop('checked', true).trigger('change');

    $('#rule_tie_option_' + preset.tie).prop('checked', true).trigger('change');

    checkRuleFormCompletion();
  }

  Object.keys(presets).forEach(function (btnId) {
    const btn = $('#' + btnId);
    if (btn.length) {
      btn.on('click', function () {
        applyPreset(presets[btnId], btn.data('ruleName'));
      });
    }
  });

  // *** 連盟公式ルール自動入力 ***
  const renmei_rule_btn = $('#renmei-rule-btn');
  if (renmei_rule_btn.length) {
    renmei_rule_btn.on('click', function () {
      if (!rule_play_type_radios.prop('disabled')) {
        $('input[name="rule[play_type]"][value="4"]').prop('checked', true).trigger('change');
      }
      if ($('input[name="rule[play_type]"]:checked').val() !== '4') return;

      $('#rule_scoring_mode_float_based').prop('checked', true);
      updateScoringModeUI(true);

      $('#rule_name').val(renmei_rule_btn.data('ruleName')).trigger('input');
      mochi.val(30).trigger('input');
      kaeshi.val(30).trigger('input');
      $('#rule_score_decimal_point_calc').val('1').trigger('change');
      $('#rule_is_chip_false').prop('checked', true).trigger('change');

      checkRuleFormCompletion();
    });
  }

  // *** リセットボタン ***
  const reset_rule_form_btn = $("#reset-rule-form");
  if (reset_rule_form_btn.length) {
    reset_rule_form_btn.on("click", function () {
      if (confirm(reset_rule_form_btn.data('resetConfirm'))) {
        // scoring_modeをstandardに戻す
        $('#rule_scoring_mode_standard').prop('checked', true);
        updateScoringModeUI(true);

        rule_name.val("");
        rule_mochi.val("");
        rule_kaeshi.val("");
        rule_uma_one.val("");
        rule_uma_two.val("");
        rule_uma_three.val("");
        rule_uma_four.val("");
        rule_score_decimal_point_calc.val("1");
        $("#rule_tie_option_1").prop("checked", true).trigger("change");
        $("#rule_is_chip_false").prop("checked", true).trigger("change");
        rule_chip_rate.val("");

        // リセット後にUI状態（送信ボタン/チップpt入力可否）を最新化する
        updateChipRateField();
        checkRuleFormCompletion();
      }
    });
  }

  // *** 成績紐づき時の全フィールドロック ***
  function lockFieldsForMatchedRule() {
    if (typeof gon === 'undefined' || !gon.has_matches) return;

    rule_play_type_radios.prop('disabled', true);
    mochi.prop('disabled', true);
    kaeshi.prop('disabled', true);
    scoring_mode_radios.prop('disabled', true);
    uma_one.prop('disabled', true);
    uma_two.prop('disabled', true);
    uma_three.prop('disabled', true);
    uma_four.prop('disabled', true);
    $('#rule_score_decimal_point_calc').prop('disabled', true);
    rule_tie_option_radios.prop('disabled', true);
    rule_is_chip_radios.prop('disabled', true);
    rule_chip_rate.prop('disabled', true);

    // 送信ボタンは有効のまま（name と description は編集可能）
    $('#rule_create_btn').prop('disabled', false).removeClass('inactive');
  }

  // *** scoring_modeイベントリスナー ***
  scoring_mode_radios.on('change', function() {
    updateScoringModeUI(true);
  });

  // 初期ロード時にscoring_mode UIを反映（既存値を保持）
  updateScoringModeUI(false);
  updateScoringModeAvailability();
  updateTemplateAvailability();

  // 成績紐づき時は全フィールドロック（updateScoringModeUI の後に実行）
  lockFieldsForMatchedRule();

  // 初期ロード時にチェック実行
  checkRuleFormCompletion();

  // フォーム項目の変更時にチェック実行
  rule_play_type_radios.on("change", checkRuleFormCompletion);
  rule_name.on("input", checkRuleFormCompletion);
  rule_mochi.on("input", checkRuleFormCompletion);
  rule_kaeshi.on("input", checkRuleFormCompletion);
  rule_uma_one.on("input", checkRuleFormCompletion);
  rule_uma_two.on("input", checkRuleFormCompletion);
  rule_uma_three.on("input", checkRuleFormCompletion);
  rule_uma_four.on("input", checkRuleFormCompletion);
  rule_score_decimal_point_calc.on("change", checkRuleFormCompletion);
  rule_tie_option_radios.on("change", checkRuleFormCompletion);
  rule_is_chip_radios.on("change", checkRuleFormCompletion);
  rule_chip_rate.on("input", checkRuleFormCompletion);
});
